import API from '../utils/api';
import LocalStorageService from './localStorage';
import { ExternalAuthConfig } from '../pages/externalAuth/types';

const localStorageService = (LocalStorageService as any).getService();

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorageService.getAccessToken()}`,
  },
});

const basePath = (orgId: string) =>
  `external-auth/external-auth/${encodeURIComponent(orgId)}`;

export const fetchExternalAuthList = (orgId: string) =>
  API.get(basePath(orgId), authHeaders());

export const fetchExternalAuthById = (orgId: string, id: string) =>
  API.get(`${basePath(orgId)}/${encodeURIComponent(id)}`, authHeaders());

export const createExternalAuth = (
  orgId: string,
  data: Omit<ExternalAuthConfig, 'id'>,
) => API.post(basePath(orgId), data, authHeaders());

export const updateExternalAuth = (
  orgId: string,
  id: string,
  data: Omit<ExternalAuthConfig, 'id'>,
) =>
  API.put(`${basePath(orgId)}/${encodeURIComponent(id)}`, data, authHeaders());

export const deleteExternalAuth = (orgId: string, id: string) =>
  API.delete(`${basePath(orgId)}/${encodeURIComponent(id)}`, authHeaders());

export const fetchExternalAuthStatus = (orgId: string, id: string) =>
  API.get(`${basePath(orgId)}/${encodeURIComponent(id)}/status`, authHeaders());

export const fetchAuthorizeUrl = (orgId: string, id: string) =>
  API.get(
    `${basePath(orgId)}/${encodeURIComponent(id)}/authorize`,
    authHeaders(),
  );

export const fetchExternalAuthToken = (orgId: string, id: string) =>
  API.get(
    `${basePath(orgId)}/${encodeURIComponent(id)}/get-token`,
    authHeaders(),
  );

export const getCertificateUploadUrl = (orgId: string, id: string) =>
  API.get(
    `${basePath(orgId)}/${encodeURIComponent(id)}/certificate`,
    authHeaders(),
  );

export const confirmCertificateUpload = (
  orgId: string,
  id: string,
  fileName: string,
) =>
  API.post(
    `${basePath(orgId)}/${encodeURIComponent(id)}/certificate`,
    { fileName },
    authHeaders(),
  );
